import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '@/store/convo/state'
import { RootState } from '@/store'
import { IConvo } from '@/model/convo'
import convoStore from '@/store/convo/convo-store'

export default async function editConvoStatements(context: BareActionContext<ConvoState, RootState>, convo: IConvo)
{
    convoStore.commitEditConvoStatements({ convo: convo })

    return
}